module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./MyBeanView.js"));
	}, "BeanHomeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BeanHomeView!./src/pages/PunchClock/Bean/MyBean/MyBeanView.js
// module id = 2254
// module chunks = 367